module.exports = __webpack_public_path__ + "static/media/7.cfe2b64d.jpg";